<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <div class="card mt-n3">
    <div class="card-header">
      <div class="row g-2">
        <div class="col-sm-4" style="display: none;">
          <div class="search-box">
            <input type="text" class="form-control" placeholder="Search for name, tasks, projects or something...">
            <i class="ri-search-line search-icon"></i>
          </div>
        </div>
        <!--end col-->

        <div class="col-sm-auto ms-auto">
          <div class="list-grid-nav hstack gap-1" ngbDropdown>
            <ul ngbNav #navContactsp="ngbNav" [(activeId)]="nabTabActive" (activeIdChange)="activeIdChangeNabTab()"
              class="d-flex gap-1">
              <li [ngbNavItem]="1">
                <a ngbNavLink class="nav-link btn btn-soft-primary btn-label waves-effect waves-light btn-sm py-1"><i
                    class="ri-list-unordered label-icon align-middle fs-16 me-2"></i>
                  {{'t-owners' | translate}}
                </a>

                <ng-template ngbNavContent>
                  <app-contacts-list-developments [propertyContactsData]="contactsData" [property]="property"
                    [loginUser]="loginUser">
                  </app-contacts-list-developments>
                  <!--end row-->
                </ng-template>
              </li>
              
              <li [ngbNavItem]="2">
                <a ngbNavLink class="nav-link btn btn-soft-primary btn-label waves-effect waves-light btn-sm py-1"><i
                    class="ri-list-unordered label-icon align-middle fs-16 me-2"></i>
                  {{'t-costumers' | translate}}
                </a>

                <ng-template ngbNavContent>
                  <app-contacts-list-developments [propertyContactsData]="contactsData" [property]="property"
                    [loginUser]="loginUser">
                  </app-contacts-list-developments>
                  <!--end row-->
                </ng-template>
              </li>
            </ul>

            <button class="btn btn-outline-primary waves-effect waves-primary add-btn btn-sm" id="create-btn"
              (click)="openModal()" [class.placeholder]="hideElement" [attr.disabled]="hideElement ? true: null"
              *ngIf="permissionsService.checkAgentPermission(property?.mainAgent, 'EDIT_PROPERTIES') || permissionsService.canEditProperty(loginUser, property?.store?.id) || !property">
              <i class="ri-add-line align-bottom me-1"></i>
              {{ textAddContact | translate}}
            </button>
          </div>
        </div>
        <!--end col-->
      </div>
      <!--end row-->

    </div>
    <div class="card-body">
      <div class="row align-items-center">
        <div class="col">
          <div class="tab-content text-muted">
            <div [ngbNavOutlet]="navContactsp"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-simplebar>

<app-contacts-create-edit-developments></app-contacts-create-edit-developments>